import { PoStorageService } from '@po-ui/ng-storage';

export interface IFiltroRelatorioLotes {
  lastSetDefault: Date;

  CZ02LOTE: string;
  CZ02PEDIDO: string;
  CZ02PEDDES: string;
  CZ02UR: string;
  CCOMSALDO: string;
}

export class FiltroRelatorioLotes {

  dados: IFiltroRelatorioLotes;
  storageName: string;

  constructor(private poStorageService: PoStorageService) {

    this.dados = this.setDefault();
    this.storageName = 'interface-filtro-relatorio-lotes';

    this.poStorageService.get(this.storageName).then((filtro: IFiltroRelatorioLotes) => {
      if (filtro) {

        const {
          lastSetDefault,
        } = filtro;

        if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
          this.dados = this.setDefault();
        } else {
          this.dados = {
            ...filtro,
            lastSetDefault: new Date(lastSetDefault),
          };
        }
      }
    });
  }

  public setDefault = (): IFiltroRelatorioLotes => {
    return {
      lastSetDefault: new Date(),
      CZ02LOTE: '',
      CZ02PEDIDO: '',
      CZ02PEDDES: '',
      CZ02UR: '',
      CCOMSALDO: 'N',
    };
  }

  public setStorage = (): void => {
    this.poStorageService.set(this.storageName, this.dados);
  }

  private getData = (dias: number): Date => {
    const dataDe = new Date();
    dataDe.setDate(dataDe.getDate() + dias);
    return dataDe;
  }

}
